module.exports = __webpack_public_path__ + "files/6bcdd238bd3875c3d8011827b6159330.png";